import { Location } from './components/types';

export const getCommonLocationIds = (selectedLocations: Location[][]) => {
  if (selectedLocations.length === 0) {
    return new Set([]);
  }
  const commonLocationIds = new Set(selectedLocations[0].map((loc) => loc.id));

  selectedLocations.slice(1).forEach((locations) => {
    const locationIds = new Set(locations.map((loc) => loc.id));
    for (const id of commonLocationIds) {
      if (!locationIds.has(id)) {
        commonLocationIds.delete(id);
      }
    }
  });

  return commonLocationIds;
};
